import { render } from "./thirdstepLoggedGrooming.vue?vue&type=template&id=78e5f2c6&scoped=true"
import script from "./thirdstepLoggedGrooming.vue?vue&type=script&lang=js"
export * from "./thirdstepLoggedGrooming.vue?vue&type=script&lang=js"

import "./thirdstepLoggedGrooming.vue?vue&type=style&index=0&id=78e5f2c6&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e5f2c6"]])

export default __exports__